// frontend/src/components/layouts/ScrollToTop.js
// frontend/src/components/layouts/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    
    useEffect(() => {
        // Implement multiple approaches to ensure scrolling works
        
        // Approach 1: Immediate scroll to top
        window.scrollTo(0, 0);
        
        // Approach 2: Delay scroll to allow DOM to update first
        const timeoutId = setTimeout(() => {
            window.scrollTo(0, 0);
            
            // Approach 3: Use scrollIntoView on the document body
            document.body.scrollIntoView({ 
                behavior: 'auto',
                block: 'start'
            });
            
            // Approach 4: Force layout recalculation and then scroll
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0; // For Safari
        }, 0);
        
        // Cleanup timeout on component unmount
        return () => clearTimeout(timeoutId);
    }, [pathname]);
    
    // This component doesn't render anything visible
    return null;
};

export default ScrollToTop;